import { Carxteam, Ingeprop, Opesnfac, Taskgraf, Aleteleg, Aledocxx, Userturx } from "./Graphics";
import Criticid from "./Graphics/Criticid";
import Teincome from "./Graphics/Teincome";

/**
 * Componente para seleccionar la grafica a pintar
 */
export function Graphsel({
  graphName,
  graphComponent,
  MODIDXXX,
  PROIDXXX,
  graphKeyName,
  filtersFieldsGraph
}) {

  const properties = {
    graphName,
    MODIDXXX,
    PROIDXXX,
    graphKeyName,
    filtersFieldsGraph,
  };

  const types = {
    Taskgraf: <Taskgraf {...properties} />,
    Carxteam: <Carxteam {...properties} />,
    Ingeprop: <Ingeprop {...properties} />,
    Aleteleg: <Aleteleg {...properties} />,
    Aledocxx: <Aledocxx {...properties} />,
    Opesnfac: <Opesnfac {...properties} />,
    Teincome: <Teincome {...properties} />,
    Userturx: <Userturx {...properties} />,
    Criticid: <Criticid {...properties} />,
  };

  return <>{types[graphComponent]}</>;
}
